module.exports = __webpack_public_path__ + "img/impact-story-3.d39056d5.png";